import { FunctionComponent, PropsWithChildren } from 'react';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { StateFromReducersMapObject } from 'redux';

import { CoreRootState, CoreStoreProvider, createGameStore } from '@pp/core';

import { mwGameStateSlice } from './slices/mwGame/slice';
import { mwGameGridMiddleware } from './slices/mwGameGrid/middleware';
import { mwGameGridSlice } from './slices/mwGameGrid/slice';
import { mwStateSlice } from './slices/mwState/slice';

const gameReducer = {
  [mwGameStateSlice.name]: mwGameStateSlice.reducer,
  [mwGameGridSlice.name]: mwGameGridSlice.reducer,
  [mwStateSlice.name]: mwStateSlice.reducer,
};

export const GameStore = createGameStore(gameReducer, { middleware: [mwGameGridMiddleware.middleware] });
export type GameStore = typeof GameStore;

export type GameRootState = StateFromReducersMapObject<typeof gameReducer> & CoreRootState;
export const useGameSelector: TypedUseSelectorHook<GameRootState> = useSelector;

export type GameDispatch = GameStore['dispatch'];

export const useGameDispatch: () => GameDispatch = useDispatch;

export const GameStoreProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
  return <CoreStoreProvider store={GameStore}>{children}</CoreStoreProvider>;
};
